import './missioncatering/style';
import FormStructure from './missioncatering/form_structure';

export default FormStructure;